import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminRoutes from "./routes/AdminRoutes";
import CustomerRoutes from "./routes/CustomerRoutes";
import SupplierRoutes from "./routes/SupplierRoutes";
import ShopRoutes from "./routes/ShopRoutes";
import AuthRoutes from "./routes/AuthRoutes";
import CarrierRoutes from "./routes/CarrierRoutes";
import DriverRoutes from "./routes/DriverRoutes";
import { CategoryTreeProvider } from './context/CategoryTreeContext';
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  return (
      <>
      <Toaster />
          <CategoryTreeProvider>
            <Router>
              <ScrollToTop />
              <Routes>
                  {/*<Route path="/" element={<HomePage />} />*/}
                  {AdminRoutes()}
                  {CustomerRoutes()}
                  {SupplierRoutes()}
                  {ShopRoutes()}
                  {CarrierRoutes()}
                  {DriverRoutes()}
                  {AuthRoutes()}
              </Routes>
            </Router>
          </CategoryTreeProvider>
      </>
  );
}
